export { default } from './InsuredEmployeesChart';
